module.exports = __webpack_public_path__ + "img/userPic.064dde9c.png";